export enum PortalName {
  CP = 'client-portal',
  BP = 'bank-portal',
  BOP = 'back-office-portal'
}
